import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './Login/Login.scss';

import ViewLoginLogo from './Login/ViewLoginLogo';
import CustomLoginLogo from './Login/CustomLoginLogo';
import PCCLoginLogo from './Login/PCCLoginLogo';
import LoginForm from './Login/LoginForm';
import LoginFooter from './Login/LoginFooter';
import LoginFormTitle from './Login/LoginFormTitle';
import LoginFormItem from './Login/LoginFormItem';
import LoginFormLinks from './Login/LoginFormLinks';

import SingleSignOnContent from './Login/SingleSignOnContent';
import SingleSignOnGoogleButton from './Login/SingleSignOnGoogleButton';
import SingleSignOnAzureButton from './Login/SingleSignOnAzureButton';
import SingleSignOnBarracudaButton from './Login/SingleSignOnBarracudaButton';

export {
    ViewLoginLogo,
    CustomLoginLogo,
    PCCLoginLogo,
    LoginForm,
    LoginFooter,
    LoginFormTitle,
    LoginFormItem,
    LoginFormLinks,
    SingleSignOnContent,
    SingleSignOnGoogleButton,
    SingleSignOnAzureButton,
    SingleSignOnBarracudaButton,
};

function Login(props) {
    return (<section
        className={styles['login-container']}
        data-section="login-container"
    >
        {props.children}
    </section>)
}

Login.displayName = displayName('Login');

Login.propTypes = {
    children: PropTypes.node,
};

Login.defaultProps = {
    children: null,
};

export default Login;
